var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorLocateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.15884 0 0.234375 3.92691 0.234375 8.77036C0.234375 14.1025 3.88791 15.359 5.80477 18.6282C7.5893 21.6705 7.59075 24 9 24C10.4614 24 10.3692 21.8299 12.1952 18.6283C14.0208 15.4261 17.7656 14.1025 17.7656 8.77036C17.7656 3.92691 13.8412 0 9 0ZM9 12.1313C7.18894 12.1313 5.72072 10.6624 5.72072 8.85056C5.72072 7.94414 6.08775 7.1242 6.68133 6.53025C7.27486 5.93677 8.09447 5.56927 9 5.56927C10.8111 5.56927 12.2788 7.03823 12.2788 8.85056C12.2788 10.6624 10.8111 12.1313 9 12.1313Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99789 0C8.75391 0 8.51241 0.0104531 8.27344 0.03C12.7756 0.398625 16.3146 4.17098 16.3146 8.77036C16.3146 14.1025 12.5698 15.4261 10.7442 18.6282C9.29794 21.164 9.05489 23.0525 8.29027 23.7284C8.4863 23.9049 8.71341 24 8.99789 24C10.4593 24 10.3671 21.8299 12.1931 18.6283C14.0187 15.4261 17.7635 14.1025 17.7635 8.77036C17.7635 3.92691 13.839 0 8.99789 0Z",
    fill: "#43A047"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68119 6.5307L0.918094 12.2969C0.496547 11.3363 0.234375 10.2 0.234375 8.77077C0.234375 6.36903 1.19934 4.19314 2.76206 2.60938L6.68119 6.5307Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.34 11.1441C11.9198 10.5523 12.2774 9.74167 12.2774 8.84753C12.2774 7.0352 10.8093 5.56628 8.9985 5.56628C8.09283 5.56628 7.27312 5.93364 6.67969 6.52741L12.4852 0.71875C14.5603 1.61945 16.2182 3.30011 17.0907 5.39106L11.3402 11.1447L11.34 11.1441Z",
    fill: "#42A5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4894 0.71875L12 1.20841C13.947 2.35722 15.4114 4.23714 16.0156 6.47097L17.095 5.39106C16.2225 3.30006 14.5645 1.61945 12.4894 0.71875Z",
    fill: "#2196F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3455 11.1485L5.01613 17.4814C3.63997 15.7469 1.87433 14.4717 0.921875 12.2975L6.68497 6.53125C6.09153 7.12502 5.72436 7.94519 5.72436 8.85137C5.72436 10.6631 7.19249 12.1321 9.00378 12.1321C9.92094 12.1321 10.7502 11.7552 11.3453 11.1479L11.3455 11.1485Z",
    fill: "#FFC107"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4903 0.721687L6.68475 6.53039L2.76562 2.60911C4.35506 0.998156 6.56292 0 9.00361 0C10.2427 0 11.422 0.257437 12.4903 0.721687Z",
    fill: "#1E88E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99794 0C8.754 0 8.5125 0.0104062 8.27358 0.03C8.27353 0.03 8.27348 0.0300469 8.27344 0.0300469C9.62395 0.140625 10.8876 0.557766 11.9953 1.21134L12.4846 0.721688C11.4163 0.257437 10.237 0 8.99794 0Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorLocateIcon);
export default __webpack_public_path__ + "static/media/colorLocateIcon.a34e3abf9b8f5eecec9a9f86d1ad4bf0.svg";
export { ForwardRef as ReactComponent };